type LockedTextFieldProps = {
  label?: string;
  value: string;
};

export const LockedTextField = (props: LockedTextFieldProps) => {
  return (
    <div className="flex flex-col gap-2">
      {props.label && <span className="text-body-small text-white-80">{props.label}</span>}
      <div className="flex w-full cursor-default items-center rounded border border-white-20 bg-white-4 px-5 py-[10px] text-body-small font-semibold text-white-60">
        {props.value}
      </div>
    </div>
  );
};
